import App from './App.svelte';

const app = new App({
	target: document.getElementById('bensinkalkulator'),
});

export default app;
